export const POST_SALE_COMPLETED_SALE_KEY = 'saleCompleteModalShown';
